// @ts-check

/**
 * @typedef {{ currency: string, currencySymbol: string, locale: string }} AppSettings
 */

/**
 * Format a number as a currency string using the app's locale settings.
 * @param {number|null|undefined} amount
 * @param {AppSettings} settings
 * @returns {string}
 */
export function formatCurrency(amount, settings) {
  if (amount === null || amount === undefined) return '—';
  try {
    return new Intl.NumberFormat(settings.locale, {
      style: 'currency',
      currency: settings.currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${settings.currencySymbol}${Number(amount).toFixed(2)}`;
  }
}

/** @param {string} dateStr - YYYY-MM-DD @param {Partial<AppSettings>} [settings] @returns {string} */
export function formatDate(dateStr, settings = {}) {
  if (!dateStr) return '';
  try {
    if (settings?.locale) {
      return new Intl.DateTimeFormat(settings.locale, {
        day: '2-digit', month: '2-digit', year: 'numeric',
      }).format(new Date(dateStr + 'T00:00:00'));
    }
  } catch {}
  const [y, m, d] = dateStr.split('-');
  return `${d}/${m}/${y}`;
}

export function todayStr() {
  return new Date().toISOString().split('T')[0];
}

export function yesterdayStr() {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return d.toISOString().split('T')[0];
}

/** Generate a unique ID with an optional prefix. @returns {string} */
export function uuid() {
  return 'id_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
}
